// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createStore } from "effector";
import { authentifiedUserEvent, logout } from "./AuthEvents";
import logger from "../../utils/logger";
import { AuthentifiedUser } from "../../api/backend-openapi";

export const authentifiedUserStore = createStore<AuthentifiedUser | null>(null);
authentifiedUserStore.on(authentifiedUserEvent, (state, payload) => {
  return payload === undefined ? null : payload;
});

logout.watch(() => {
  logger.debug("Clear storage");
  localStorage.clear();
  sessionStorage.clear();
});
